import { SkeletonText } from '@chakra-ui/react';
import { Icon } from '@mercator-gcp/grout';
import { TLeadContext } from 'components/elements/LeadsTable/types';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { Panel } from 'components/layout/Panel';
import ProjectCard from 'components/widgets/ProjectCard';
import { ViewProjectDetailsClickLocations } from 'utils/analytics/constants';

type PastProjectProps = {
  projectsList: any;
  loading: boolean;
  mapLoading: boolean;
  leadContext?: TLeadContext;
  keyPrefix?: string;
  children?: string;
};

const PastProjects = ({
  projectsList,
  loading,
  mapLoading,
  leadContext,
  keyPrefix = 'same-address-',
  children,
}: PastProjectProps) => {
  const containerStyle = {
    gap: 'padding_16',
  };

  return (
    <Panel title={children || ''} icon={<Icon name={Icon.Name.MapMarker} />}>
      <SkeletonText isLoaded={!loading && !mapLoading}>
        <FlexColumn sx={containerStyle}>
          {projectsList.map((project: any) => {
            return (
              <ProjectCard
                key={`${keyPrefix}-project-list-item-${project.slug}`}
                project={project}
                clickLocation={ViewProjectDetailsClickLocations.LIST}
                leadContext={leadContext}
              />
            );
          })}
        </FlexColumn>
      </SkeletonText>
    </Panel>
  );
};

export default PastProjects;
